module.exports = __webpack_public_path__ + "static/media/success(24) (Custom).c03ad3f7.png";